// Profil-Seite (read-only): zeigt den angemeldeten Sachbearbeiter.
// Im Cloud-Modell gibt es (noch) keine per-User-Einstellungen — der frühere
// lokale „Eingangs-Ordner" ist ein Local-Backend-Konzept und entfällt.

import { useCurrentUser } from "@/api/hooks";
import { Loader } from "@/components/Loader";
import { PageHeader } from "@/components/PageHeader";

import "./SettingsPage.css";

export function SettingsPage() {
  const me = useCurrentUser();

  if (me.isLoading) return <Loader />;
  if (!me.data) return null;

  const user = me.data;

  return (
    <>
      <PageHeader
        title="Mein Profil"
        subtitle="Dein Sachbearbeiter-Konto in der Cloud."
      />

      <div className="bmd-card">
        <dl className="bmd-detail-dl">
          <dt>Name</dt>
          <dd>{user.full_name || "—"}</dd>
          <dt>E-Mail</dt>
          <dd className="bmd-mono">{user.email}</dd>
          <dt>Kanzlei (Tenant)</dt>
          <dd className="bmd-mono bmd-subtle">{user.tenant_id}</dd>
        </dl>
      </div>
    </>
  );
}
